export default "__VITE_ASSET__D8k0Xs3K__"